import type { ApiRoute, NoQueryParams } from "../../../api"
import type { ListingDescriptionChange } from "../../../common/listingDescription/ListingDescriptionChange"
import type { ListingDescriptionView } from "./ListingDescriptionView"

export interface UpdateListingDescriptionPathParams {
	inventoryId: string
}

export const updateListingDescriptionRoute: ApiRoute<
	UpdateListingDescriptionPathParams,
	NoQueryParams,
	ListingDescriptionChange,
	ListingDescriptionView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/listing-description`,
	method: "patch",
	path: "/vehicles/:inventoryId/listing-description",
}
